import { memo } from 'react';
import { HStack, Text } from '@adc/parallax-component-library';
import { IconValidationInvalid } from '@adc/parallax-icons';

import { buildTestId } from '~/utilities/buildTestId';

type Props = {
  errorMessage?: string;
  testID?: string;
};

// TODO: remember to delete when fully moved to parallax inputs
export const InputErrorField = memo(({ testID, errorMessage }: Props) => {
  if (!errorMessage) {
    return null;
  }

  return (
    <HStack marginBottom="$2">
      <IconValidationInvalid
        color="$support.danger.surfaceOnColorAlt"
        testID={buildTestId({
          testID,
          suffix: 'icon',
        })}
      />
      <Text
        display="flex"
        testID={buildTestId({ testID, suffix: 'message' })}
        color="$support.danger.surfaceOnColorAlt"
        fontSize="$bodySmall.default"
        marginLeft="$2"
      >
        {errorMessage}
      </Text>
    </HStack>
  );
});

InputErrorField.displayName = 'InputErrorField';
